/**
 * Available entities for reference fields.
 * Maps display labels (shown to users) to actual entity values (stored in the system).
 * This allows flexibility to show user-friendly names while using different internal entity names.
 *
 * @example
 * // Current usage - label matches value
 * { label: 'Organization', value: 'Organization' }
 *
 * @example
 * // Future usage - label differs from value
 * { label: 'Attachments', value: 'Document' }
 */
export const AVAILABLE_REFERENCE_ENTITIES = [
    {
        label: 'Organization',
        value: 'Organization'
    },
    {
        label: 'Person',
        value: 'Person'
    }
] as const;

export type ReferenceEntityValue = (typeof AVAILABLE_REFERENCE_ENTITIES)[number]['value'];
